import ESTIMATE_CONSTANT from "../../../constant/estimateConstant"
import getNumberOfLayers from "../../../service/getNumberOfLayers"
import { isMultiLayer } from "../../../service/oneClickIs"
import type EstimateValues from "../../../types/params"
import getNumberOfMinPattern from "../getNumberOfMinPattern"

const isValidFpcBoardThickness = (values: EstimateValues, fpcBoardThickness?: string) => {
  const numberOfMinPattern = getNumberOfMinPattern(values)
  const numberOfLayers = getNumberOfLayers(values)

  switch (fpcBoardThickness) {
    case ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm未満)"].value:
    case ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm未満)"].value:
      return numberOfMinPattern < 0.1 && !isMultiLayer(values)

    case ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__2層)"].value:
    case ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__2層)"].value:
      return numberOfMinPattern >= 0.1 && numberOfLayers === 2

    case ESTIMATE_CONSTANT.ベース材厚["12.5μm(0.1mm以上__片面)"].value:
    case ESTIMATE_CONSTANT.ベース材厚["25μm(0.1mm以上__片面)"].value:
      return numberOfMinPattern >= 0.1 && numberOfLayers === 1

    case ESTIMATE_CONSTANT.ベース材厚["12.5μm(3層)"].value:
      return numberOfLayers === 3
    case ESTIMATE_CONSTANT.ベース材厚["12.5μm(4層)"].value:
      return numberOfLayers === 4

    default:
      return false
  }
}

export default isValidFpcBoardThickness
